import React, {Fragment} from 'react'
import down from 'pages/HealthCenter/ReportV1/HealthCenterMajorIndicators/down.svg'
import useGaugeStyles from 'pages/HealthCenter/ReportV1/BrainFunctionalConnectivity/Elements/components/style'

interface Props {
  index: number
  percentage: number
}
function ProcessArrow({index, percentage}: Props) {
  const classes = useGaugeStyles()

  return (
    <Fragment>
      {index === 3 ? (
        <div className={classes.processArrowV}>
          <img
            className={classes.percentBarV2Arrow}
            style={{marginLeft: `${percentage - 1}%`, position: 'absolute'}}
            src={down}
            alt='icon'
          />
        </div>
      ) : (
        <div>
          <div className={classes.processArrowV1}>
            <img
              style={{
                top: `${100 - percentage}%`,
                height: '8px',
                transform:
                  index === 1
                    ? 'translateY(-50%) rotate(90deg)'
                    : 'translateY(-50%) rotate(270deg)',
                position: 'absolute',
              }}
              src={down}
              alt='icon'
            />
          </div>
        </div>
      )}
    </Fragment>
  )
}
export default ProcessArrow
